import { render, staticRenderFns } from "./MenuDropdown.vue?vue&type=template&id=18e9bd07&scoped=true&"
import script from "./MenuDropdown.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MenuDropdown.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./MenuDropdown.vue?vue&type=style&index=0&id=18e9bd07&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e9bd07",
  null
  
)

export default component.exports